import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { ApolloProvider } from '@apollo/client';
import { useAssistantContext, AssistantProvider } from '../context/AssistantContext.jsx';
import AIAssistantLayout from '../../../../ui/layouts/AIAssistantLayout.jsx';
import ConversationSidebar from '../components/ConversationSidebar.jsx';
import AssistantChat from '../components/AssistantChat.jsx';
import client from '../../lib/apolloClient';

function SidebarSlot() {
  const { conversations, handleNewConversation } = useAssistantContext();
  return <ConversationSidebar conversations={conversations} onNewConversation={handleNewConversation} />;
}

function ChatSlot({ branded, georgeCoachEnabled }) {
  const { currentMessages, isThinking, handleSendMessage, suggestedTopics } = useAssistantContext();
  return (
    <AssistantChat
      messages={currentMessages}
      onSendMessage={handleSendMessage}
      suggestedTopics={suggestedTopics}
      isThinking={isThinking}
      companyBrandedName={branded}
      georgeCoachEnabled={georgeCoachEnabled}
    />
  );
}

export default function AssistantPage({ initialCompanyBrandedName, initialPrompt, georgeCoachEnabled = false }) {
  const containerRef = useRef(null);
  const [containerStyle, setContainerStyle] = useState({ height: '100vh' });

  console.log('[AssistantPage component] Received initialPrompt:', initialPrompt);

  useLayoutEffect(() => {
    function syncHeight() {
      if (!containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const available = Math.max(window.innerHeight - rect.top, 320);
      setContainerStyle({ height: available + 'px', overflow: 'hidden' });
    }
    syncHeight();
    window.addEventListener('resize', syncHeight);
    return () => window.removeEventListener('resize', syncHeight);
  }, []);

  const brandedFromStore = (typeof document !== 'undefined' && document.store?.getState?.()?.company?.branded_name) || '';
  const branded = initialCompanyBrandedName || brandedFromStore;
  return (
    <ApolloProvider client={client}>
      <AssistantProvider initialPrompt={initialPrompt}>
        <div ref={containerRef} style={containerStyle} className="min-h-0">
          <AIAssistantLayout sidebar={<SidebarSlot />}>
            <ChatSlot branded={branded} georgeCoachEnabled={georgeCoachEnabled} />
          </AIAssistantLayout>
        </div>
      </AssistantProvider>
    </ApolloProvider>
  );
}



